module.exports = __webpack_public_path__ + "static/media/Product.4c101da8.jpg";